// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"1b80a4e7","72":"d6ff6337","253":"8c59ddc6","331":"1c9ff415","391":"98ad74ec","653":"c784a9e0","686":"15ba72d5","687":"a40b7627","871":"b02ea42e","920":"86bfcec1"}[chunkId] + ".chunk.css";
};